const SoftwareComponent = () => (
    <section id="software" className="py-12 relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black"></div>
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center mb-20">
                <h2 className="text-3xl sm:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-orange-600 h-12">
                    Oprogramowanie
                </h2>
            </div>

            <div className="grid lg:grid-cols-2 gap-12 items-center">
                <div>
                    <h3 className="text-4xl font-bold mb-6 text-white">CageEEG Studio</h3>
                    

                    <div className="space-y-6 flex flex-col w-3/4">
                        <div className="flex gap-4">

                            <div className="w-1/3">
                                <div
                                    className="flex-shrink-0 w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">
                                    <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M13 10V3L4 14h7v7l9-11h-7z"></path>
                                    </svg>
                                </div>
                            </div>

                            <div className="w-2/3">
                                <h4 className="font-semibold text-white mb-2">Analiza w czasie rzeczywistym</h4>
                                <p className="text-gray-400">Przetwarzanie sygnału z minimalnym opóźnieniem</p>
                            </div>
                        </div>

                        <div className="flex gap-4 w-full">
                            <div className="w-1/3">
                                <div
                                    className="flex-shrink-0 w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">
                                    <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 110-4m0 4v2m0-6V4"></path>
                                    </svg>
                                </div>
                            </div>

                            <div className="w-2/3">
                                <h4 className="font-semibold text-white mb-2">Rozpoznawanie intencji</h4>
                                <p className="text-gray-400">Sieci neuronowe CNN, RNN</p>
                            </div>

                        </div>

                        <div className="flex gap-4 w-full">
                            <div className="w-1/3">
                                <div
                                    className="flex-shrink-0 w-12 h-12 bg-orange-500/20 rounded-xl flex items-center justify-center">
                                    <svg className="w-6 h-6 text-orange-500" fill="none" stroke="currentColor"
                                         viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                                              d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
                                    </svg>
                                </div>
                            </div>

                            <div className="w-2/3">
                                <h4 className="font-semibold text-white mb-2">Integracja z MATLAB/Python</h4>
                                <p className="text-gray-400">API do własnych skryptów i analiz</p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="relative">
                    <div
                        className="absolute inset-0 bg-gradient-to-r from-orange-500/20 to-orange-600/20 blur-3xl"></div>
                    <div className="relative bg-white/5 backdrop-blur-sm rounded-3xl p-10 border border-white/10">
                        <h4 className="text-2xl font-bold text-orange-500 mb-8">Funkcje dodatkowe przewidziane w programie</h4>
                        <div className="grid grid-cols-1 gap-4">
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Mapowanie topograficzne 3D</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Analiza spektralna FFT</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Detekcja intencji AI</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Eksport do formatu CSV/JSON/inne</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Moduł analizy snu</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Protokoły badawcze LSL</span>
                            </div>
                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Klasyfikacja emocji</span>
                            </div>

                            <div className="flex items-center gap-3">
                                <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
                                <span className="text-gray-300">Interfejs mózg-komputer</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
    )

export default SoftwareComponent
